export const paths = {
  home: 'home',
  about: 'about',
  contact: 'contact',
};
